<template>
    <div>
        <div class="bg-white flex flex-col justify-between items-center minHeightCard h-full widthCard rounded-lg">
            <div class="mt-1">
                <Star :score="score" />
            </div>
            <p class="review-text text-sm px-3 text-center">
                "{{ truncatedText }}"
                <button v-if="isTextTruncated" class="read-more-btn" @click="checkTextLength">Read full review</button>
            </p>
            <p class="review-text name mb-3 font-bold text-sm text-center">{{ reviewerName }}</p>
        </div>
    </div>
</template>

<script>
import Star from '@/js/components/Star.vue';
import { ScreenSize } from '@/js/util/screensize';

export default {
    components: {
        Star,
    },
    props: {
        score: {
            type: Number,
            required: true,
            validator: function (value) {
                return value >= 0 && value <= 5;
            },
        },
        reviewerName: {
            type: String,
            required: true,
        },
        reviewText: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            maxLength: 150,
        };
    },
    computed: {
        isTextTruncated() {
            return this.reviewText.length > this.maxLength;
        },
        truncatedText() {
            if (this.isTextTruncated) {
                return this.reviewText.substring(0, this.maxLength) + '...';
            }
            return this.reviewText;
        },
    },
    methods: {
        checkTextLength() {
            if (this.isTextTruncated) {
                const popupData = {
                    text: this.reviewText,
                    name: this.reviewerName,
                    score: this.score,
                };
                this.$root.$emit('openPopup', popupData);
            }
        },
        updateMaxLength() {
            if (window.innerWidth <= ScreenSize.MOBILE) {
                this.maxLength = 100;
            } else {
                this.maxLength = 150;
            }
        },
    },
    mounted() {
        this.updateMaxLength();
        window.addEventListener('resize', this.updateMaxLength);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateMaxLength);
    },
};
</script>

<style scoped>
@media (max-width: 480px) {
    .minHeightCard {
        max-height: 150px;
        box-sizing: border-box;
    }

    .review-text {
        max-height: 100px;
    }
}

@media (max-width: 1024px) {
    .minHeightCard {
        max-height: 200px;
        box-sizing: border-box;
    }

    .review-text {
        max-height: 200px;
    }
}

.read-more-btn {
    background: none;
    border: none;
    color: blue;
    cursor: pointer;
    padding: 0;
    text-decoration: underline;
}
</style>
